<template>
  <router-view />
</template>

<script>
export default {
  name: 'UspqrpWrapper',
  data: () => ({
    page: {
      title: 'Uspqrp',
      icon: 'fas fa-user-cog',
      routes: ['Uspqrp'],
    },
  }),
  provide() {
    return {
      page: this.page,
    };
  },
};
</script>
